import React from "react";

export default function GeneralHeader(props) {
  return (
    <div className="container-fluid p-0 about-hero-section hero-section-spacing">
      <div className="row app-container">
        <div
          className="col-12 p-0 about-hero-section-box"
          style={{ background: `url(${props.backgroundImg})` }}
        >
          <h1 className="m-0 text-white">{props.heading}</h1>
          <p className="m-0 text-white">{props.tagline}</p>
        </div>
      </div>
    </div>
  );
}
